module.exports = __webpack_public_path__ + "static/10menu-46c24b85838937440e2fcf045298d88b.jpg";